module.exports = __webpack_public_path__ + "static/media/pending-selected.6f65d7d0.png";